import React, { useState, useEffect, useCallback } from 'react';
import { array } from 'prop-types';
import Swiper from 'react-id-swiper';

import { PrevArrow, NextArrow } from '@dragonfruit/components/Arrows';

import styles from './BundleBanners.scss';

function BundleBanners({ banners }) {
  const [swiper, setSwiper] = useState(null);

  const [{ isBeginning, isEnd }, setSwiperState] = useState({
    isBeginning: true,
    isEnd: false,
  });

  const hasLessBanners = banners.length <= 2;

  const swiperParams = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    shouldSwiperUpdate: true,
    centeredSlides: hasLessBanners,
    pagination: {
      el: hasLessBanners ? '.swiper-pagination-hidden' : '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  };

  useEffect(() => {
    if (!swiper) return;
    updateSwiperState(swiper);

    swiper.on('slideChange', () => updateSwiperState(swiper));
    swiper.on('toEdge', () => updateSwiperState(swiper));
  }, [updateSwiperState, swiper]);

  const updateSwiperState = useCallback(swiper => {
    const { isBeginning, isEnd } = swiper;

    setSwiperState({
      isBeginning,
      isEnd,
    });
  }, []);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  return (
    <div className={styles.root}>
      <Swiper getSwiper={setSwiper} {...swiperParams}>
        {banners.map(({ imageUrl, url }, bannerIdx) => {
          const backgroundImageStyle = imageUrl
            ? { backgroundImage: `url(${imageUrl})` }
            : null;
          return (
            <a
              href={url}
              key={bannerIdx}
              className={styles.banner}
              style={backgroundImageStyle}
            />
          );
        })}
      </Swiper>
      {!isBeginning && (
        <div onClick={goPrev} className={styles.previousButton}>
          <PrevArrow />
        </div>
      )}
      {!isEnd && (
        <div onClick={goNext} className={styles.nextButton}>
          <NextArrow />
        </div>
      )}
    </div>
  );
}

BundleBanners.propTypes = {
  banners: array.isRequired,
};

export default BundleBanners;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/BundleBanners/BundleBanners.jsx